import React from "react";

const TaskFilters = ({
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  assigneeList,
  assignedByList,
  filterAssignee,
  setFilterAssignee,
  filterAssignedBy,
  setFilterAssignedBy,
  resetFilters,
}) => {
  return (
    <div className="col-12 d-flex flex-wrap gap-2 align-items-center justify-content-end mb-3">

      <input type="date" className="form-control w-auto" value={dateFrom}
        onChange={(e) => setDateFrom(e.target.value)} />

      <input type="date" className="form-control w-auto" value={dateTo}
        onChange={(e) => setDateTo(e.target.value)} />

      <select className="form-select w-auto" value={filterAssignee}
        onChange={(e) => setFilterAssignee(e.target.value)}>
        <option value="All">All Assignees</option>
        {assigneeList.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>

      <select className="form-select w-auto" value={filterAssignedBy}
        onChange={(e) => setFilterAssignedBy(e.target.value)}>
        <option value="All">All Assigned By</option>
        {assignedByList.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>

      <button className="btn btn-secondary" onClick={resetFilters}>Reset</button>
    </div>
  );
};

export default TaskFilters;
